import { z } from 'zod';

export const subspecialtySchema = z.looseObject({
  subspecialtyId: z.coerce.number(),
  subspecialtyName: z.string(),
  description: z.union([z.string(), z.null()]),
  isScored: z.boolean(),
  parentSpecialtyId: z.coerce.number(),
});

export const specialtySchema = z.looseObject({
  specialtyId: z.coerce.number(),
  specialtyName: z.string(),
  type: z.string(),
  subspecialties: z.array(subspecialtySchema),
  description: z.union([z.string(), z.null()]),
});

export type Subspecialty = z.infer<typeof subspecialtySchema>;
export type Specialty = z.infer<typeof specialtySchema>;
